export const ENDPOINT_ORGANIZATIONAL_STRUCTURE_LIST = '/api/organizational-structure/list';
export const ENDPOINT_ORGANIZATIONAL_STRUCTURE_CREATE_ONE = '/api/organizational-structure/create';
export const ENDPOINT_ORGANIZATIONAL_STRUCTURE_DELETE_ONE = '/api/organizational-structure/delete';
